export default __webpack_public_path__ + "static/footer-22d6819c46388895ff71882e361b1c88.jpg";